import { formatPeriodToLocale } from '../../infrastructure/date.formater'

export function useDateFormatter() {
  return { formatPeriodToLocale }
}
